import React from "react";
import { observer } from "mobx-react";
import { PublisherViewStore } from "../../store";
import { PublisherViewForm } from "./PublisherViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type PublisherViewProps = {
  publisherViewStore: PublisherViewStore;
};

export const PublisherView: React.FC<PublisherViewProps> = observer(
  ({ publisherViewStore }) => {
    return (
      <div>
        <PublisherViewForm
          publisherViewStore={publisherViewStore}
          personTypeOptions={publisherViewStore.getPersonTypeOptions()}
          personType={publisherViewStore.personTypeValue}
          name={publisherViewStore.nameValue}
          maritalStatusOptions={publisherViewStore.getMaritalStatusOptions()}
          maritalStatus={publisherViewStore.maritalStatusValue}
          nationalityValue={publisherViewStore.nationalityValue}
          pseudonym={publisherViewStore.pseudonymValue}
          taxId={publisherViewStore.taxIdValue}
          phone={publisherViewStore.phoneValue}
          email={publisherViewStore.emailValue}
          streetAndNumber={publisherViewStore.streetAndNumberValue}
          floor={publisherViewStore.floorValue}
          suite={publisherViewStore.suiteValue}
          postalCode={publisherViewStore.postalCodeValue}
          countryValue={publisherViewStore.countryValue}
          provinceValue={publisherViewStore.provinceValue}
          city={publisherViewStore.cityValue}
          caeIpi={publisherViewStore.caeIpiValue}
          representativesVisibleColumns={
            publisherViewStore.representativesVisibleColumns
          }
          representativesSetColumnWiths={(x) =>
            publisherViewStore.representativesSetColumnWiths(x)
          }
          representativesRows={publisherViewStore.representativesRowsDyn}
          managementSocietiesVisibleColumns={
            publisherViewStore.managementSocietiesVisibleColumns
          }
          managementSocietiesSetColumnWiths={(x) =>
            publisherViewStore.managementSocietiesSetColumnWiths(x)
          }
          managementSocietiesRows={
            publisherViewStore.managementSocietiesRowsDyn
          }
          createdAt_={publisherViewStore.createdAt_Value}
          lastUpdatedAt_={publisherViewStore.lastUpdatedAt_Value}
          onPrint={(handlePrint: () => void) =>
            publisherViewStore.printPublisher(handlePrint)
          }
          onCancel={() => publisherViewStore.cancelPublisher()}
          onEdit={
            publisherViewStore.isEditEnabled
              ? () => publisherViewStore.editPublisher()
              : undefined
          }
        />
        <ErrorDialog
          open={publisherViewStore.errorDialogOpened}
          title={publisherViewStore.errorTitle}
          description={publisherViewStore.errorDescription}
          onClose={() => publisherViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
